import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../configuration/setup/store';
import { useAppSelector } from '../configuration/setup/hooks';

export type AccountState = {
    selectedAccountId?: string;
    selectedDeviceId?: string;
};

const initialState: AccountState = {};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        accountSelected: (state, action: PayloadAction<string | undefined>) => {
            state.selectedAccountId = action.payload;
        },
        deviceSelected: (state, action: PayloadAction<string | undefined>) => {
            state.selectedDeviceId = action.payload;
        },
    },
});

export const { accountSelected, deviceSelected } = accountSlice.actions;

export const getSelectedAccountId = (state: RootState) => state.account.selectedAccountId;

export const useSelectedAccountId = () => useAppSelector(getSelectedAccountId);

export const getSelectedDeviceId = (state: RootState) => state.account.selectedDeviceId;

export const useSelectedDeviceId = () => useAppSelector(getSelectedDeviceId);

export default accountSlice.reducer;
